import { Typography } from "@mui/material";
import React from "react";
import { Translate } from "orion-components/i18n";

const PlaybackStopped = () => {
	const styles = {
		wrapper: {
			display: "flex",
			alignItems: "center",
			flex: "auto",
			flexDirection: "column",
			justifyContent: "center",
			padding: "2.5% 8%",
			width: "100%",
			boxSizing: "border-box",
			overflow: "visible",
			zIndex: 1901
		},
		button: {
			zIndex: 99,
			marginTop: 12
		}
	};
	return (
		<div className="camera-text-wrapper" style={styles.wrapper} data-testid="orion-components-cbcomponents-video-web-rtcplayer-wowza-utils-playback-stopped-div">
			<Typography
				align="center"
				variant="subtitle1"
				style={{
					width: "100%",
					paddingInline: "0.25em",
					boxSizing: "border-box",
					whiteSpace: "normal",
					overflow: "visible",
					overflowWrap: "anywhere",
					wordBreak: "break-word"
				}}
			>
				<Translate value="global.CBComponents.video.webRTCPlayer.playbackStopped" />
			</Typography>
		</div>
	);
};

export default PlaybackStopped;
